<template>
  <v-rect :config="config" />
</template>

<script>
export default {
  name: 'Box',
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
}
</script>